import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../mock';

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section className="relative py-28 bg-[#0a0a0a]">
      <div id="FAQ" className="scroll-mt-24 max-w-[1100px] mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-amber-400 tracking-[0.32em] text-[12px] mb-5 font-medium">FAQ</p>
          <h2 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Questions, <span className="text-amber-400 italic">answered</span>
          </h2>
        </div>

        <div className="mt-14 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`rounded-2xl border transition-all duration-300 ${
                  isOpen
                    ? 'border-amber-400/50 bg-amber-400/[0.04]'
                    : 'border-white/10 bg-white/[0.02] hover:border-white/20'
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                >
                  <span className="text-white text-[17px] font-medium">{f.q}</span>
                  <span className="shrink-0 w-9 h-9 rounded-full border border-amber-400/40 text-amber-400 flex items-center justify-center">
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 text-white/65 leading-relaxed text-[15.5px]">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
